import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import AccordionItem from '../../../../components/Accordion/AccordionItem';
import InfiniteScrollTable from '../../../../components/InfiniteScrollTable';
import InsuredCell from '../../../../components/search/SearchTable/cells/InsuredCell';
import LoadingSpinner from '../../../../components/Spinner';
import {
  getSearchQueryRecipientsPage,
  selectEmailRecipientInsureds
} from '../../../../redux/modules/emails';
import { createHeaderCell } from '../../../../utils/tableUtil';
import { ColumnTypes } from '../../../ReportsPage/components/ReportTable/columns';

import PreviewCell from './PreviewCell';
import RecipientsCell from './RecipientsCell';

const RecipientsDropdown = () => {
  const insureds = useSelector(selectEmailRecipientInsureds);
  const dispatch = useDispatch();
  const [isOpen, toggleIsOpen] = useState(false);

  const { data = [], pageInfo = {} } = insureds;

  const columns = useMemo(() => [{
    justifyContent: 'flex-start',
    id: 'companyName',
    header: createHeaderCell(ColumnTypes.Insured),
    cell: InsuredCell,
    accessor: 'insured',
    colSpan: 2,
    disableSortBy: true,
    name: ColumnTypes.Insured,
    showJobName: true
  }, {
    id: 'recipients',
    header: createHeaderCell('Recipients'),
    cell: RecipientsCell,
    accessor: 'insured',
    colSpan: 1,
    disableSortBy: true,
    name: ColumnTypes.Insured
  },
  {
    id: 'preview',
    header: createHeaderCell('Preview'),
    cell: PreviewCell,
    accessor: 'insured',
    colSpan: 1,
    disableSortBy: true,
    name: ColumnTypes.Insured,
    textAlign: 'center'
  }], []);

  return (
    <AccordionItem
      isOpen={isOpen}
      title={`RECORDS (${insureds.pageInfo?.total || 'loading...'})`}
      toggle={toggleIsOpen}
    >
      {(!data || !pageInfo) ? (
        <LoadingSpinner />
      ) : (
        <InfiniteScrollTable
          columns={columns}
          data={data}
          fetchMoreData={() => dispatch(getSearchQueryRecipientsPage())}
          hasMore={pageInfo.hasMore}
          height="400px"
        />
      )}
    </AccordionItem>
  );
};

RecipientsDropdown.propTypes = {};

export default RecipientsDropdown;
